module.exports = __webpack_public_path__ + "img/wheelio2_cpg.7dd9ce0f.jpg";